import { render, staticRenderFns } from "./FloorGroupCom.vue?vue&type=template&id=3285a8fe&"
import script from "./FloorGroupCom.vue?vue&type=script&lang=ts&"
export * from "./FloorGroupCom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports